import http from 'lib/http'; // 获取行政班列表请求配置

export var urlgetSchoolActivityList = '/api/XOrg/BookMaterial/getSchoolActivityList';
export var urlAddSchoolActivity = '/api/XOrg/BookMaterial/AddSchoolActivity';
export var urlDeleteSchoolActivity = '/api/XOrg/BookMaterial/DeleteSchoolActivity';
export var urlEditSchoolActivity = '/api/XOrg/BookMaterial/EditSchoolActivity';
export var urlAuditingActivity = '/api/XOrg/BookMaterial/AuditingActivity';
export var urlverifyPaper = '/api/XOrg/BookMaterial/verifyPaper'; // 获取行政班列表

export function getSchoolActivityList(schoolCourseId, courseId, activityType, activityName, page, pageSize) {
  return http.post(urlgetSchoolActivityList, {
    schoolCourseId: schoolCourseId,
    courseId: courseId,
    activityType: activityType,
    activityName: activityName,
    page: page,
    pageSize: pageSize
  });
}
export function AddSchoolActivity(schoolCourseId, courseId, activityName, activityContent, voteType, dataJson, activityType, ActivityRemake, docJson, questionType, userType) {
  return http.post(urlAddSchoolActivity, {
    schoolCourseId: schoolCourseId,
    courseId: courseId,
    activityName: activityName,
    activityContent: activityContent,
    voteType: voteType,
    dataJson: dataJson,
    activityType: activityType,
    ActivityRemake: ActivityRemake,
    questionType: questionType,
    docJson: docJson,
    userType: userType
  });
}
export function DeleteSchoolActivity(Ids) {
  return http.post(urlDeleteSchoolActivity, {
    Ids: Ids
  });
}
export function EditSchoolActivity(activityId, activityName, activityContent, ActivityRemake, questionType, voteType, dataJson, docJson) {
  return http.post(urlEditSchoolActivity, {
    activityId: activityId,
    activityName: activityName,
    activityContent: activityContent,
    ActivityRemake: ActivityRemake,
    questionType: questionType,
    voteType: voteType,
    dataJson: dataJson,
    docJson: docJson
  });
}
export function AuditingActivity(ids) {
  return http.post(urlAuditingActivity, {
    ids: ids
  });
}
export function verifyPaper(ids, verifyType) {
  return http.post(urlverifyPaper, {
    ids: ids,
    verifyType: verifyType
  });
}